import './standaloneDescriptionSection.scss';

import { Field, TextButton } from '@approvalmax/ui';
import { RichEditorView } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { FC, memo, useCallback, useEffect, useRef, useState } from 'react';
import bemFactory from 'react-bem-factory';

import { getActiveRequest } from '../../selectors/pageSelectors';
import { messages } from './StandaloneDescriptionSection.messages';
import { StandaloneDescriptionSectionProps } from './StandaloneDescriptionSection.types';

const bem = bemFactory.block('reql-standalone-description-section');
const qa = bemFactory.qa('reql-standalone-description-section');
const MAX_COLLAPSED_HEIGHT = 100;

const StandaloneDescriptionSection: FC<StandaloneDescriptionSectionProps> = (props) => {
    const { className } = props;
    const [expanded, setExpanded] = useState(false);
    const [showExpandButton, setShowExpandButton] = useState(false);
    const request = useSelector<selectors.types.StandaloneExpandedRequest>(getActiveRequest);
    const descriptionEl = useRef<any>(null);

    const toggleExpand = useCallback(() => {
        setExpanded((prev) => !prev);
    }, []);

    useEffect(() => {
        if (descriptionEl.current && descriptionEl.current.scrollHeight > MAX_COLLAPSED_HEIGHT) {
            setExpanded(false);
            setShowExpandButton(true);
        }
    }, [request.details.description]);

    if (!request.details.description) {
        return null;
    }

    return (
        <div className={bem.add(className)()} data-qa={qa()}>
            <Field title={messages.descriptionLabel}>
                <RichEditorView
                    html={request.details.description.value}
                    highlightUrls
                    dataQa={qa('description')}
                    className={bem('description', { expanded: expanded })}
                    ref={descriptionEl}
                />
            </Field>

            {showExpandButton && (
                <div className={bem('expand-button-wrp')}>
                    <TextButton qa={qa('toggle-expand-button')} execute={toggleExpand} size='small2'>
                        {expanded ? messages.buttonShowLess : messages.buttonShowMore}
                    </TextButton>
                </div>
            )}
        </div>
    );
};

export default memo(StandaloneDescriptionSection);
